export const LIST_CONTAINER =
  'no-scrollbar flex flex-col divide-y divide-gray-200 overflow-clip rounded-lg outline outline-1 -outline-offset-1 outline-gray-200 bg-white dark:divide-gray-700 dark:outline-gray-700 dark:bg-gray-900'

export const EMPTY_STATE =
  'border border-dashed border-gray-200 px-3.5 py-2.5 text-center text-sm text-secondary dark:border-gray-700'

/** Applied to the focusable row element (inner div for handler rows, <a> for link rows). */
export const ROW_FOCUS_RING =
  'focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-blue-500'
